import styled, { css } from 'styled-components'

import { appZIndex } from '@/presentation/utils/zIndexMapper'

export type AppErrorFallbackVariant =
  'fullscreen' | 'panel' | 'floatingTopLeft' | 'floatingTopRight' | 'floatingBottomCenter'

interface ContainerProps {
  $variant: AppErrorFallbackVariant
}

interface ContentProps {
  $variant: AppErrorFallbackVariant
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $variant, theme }) =>
    $variant === 'fullscreen' &&
    css`
      width: 100%;
      min-height: 100vh;
      padding: 24px;
      background-color: ${theme.colors.secondary};
    `}

  ${({ $variant, theme }) =>
    $variant === 'panel' &&
    css`
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      padding: 24px;
      background-color: ${theme.colors.secondaryD1};
    `}

  ${({ $variant }) =>
    $variant === 'floatingTopLeft' &&
    css`
      position: absolute;
      top: 16px;
      left: 16px;
      width: min(360px, calc(100% - 32px));
      z-index: ${appZIndex.MODAL + 1};
      pointer-events: auto;
    `}

  ${({ $variant }) =>
    $variant === 'floatingTopRight' &&
    css`
      position: absolute;
      top: 16px;
      right: 16px;
      width: min(360px, calc(100% - 32px));
      z-index: ${appZIndex.MODAL + 1};
      pointer-events: auto;
    `}

  ${({ $variant }) =>
    $variant === 'floatingBottomCenter' &&
    css`
      position: absolute;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);
      width: min(360px, calc(100% - 32px));
      z-index: ${appZIndex.MODAL + 1};
      pointer-events: auto;
    `}
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`

export const Content = styled.div<ContentProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;

  width: 100%;
  max-width: ${({ $variant }) => ($variant === 'fullscreen' || $variant === 'panel' ? '440px' : '360px')};
  padding: ${({ $variant }) => ($variant === 'fullscreen' || $variant === 'panel' ? '32px 24px' : '20px 16px')};

  text-align: center;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.secondaryL1};
  box-shadow: 0px 8px 24px ${({ theme }) => `${theme.colors.secondaryD1}80`};
`

export const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutralL5};
  ${({ theme }) => theme.fonts.titleLG}
`

export const Message = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutralL5};
  ${({ theme }) => theme.fonts.infoLG}
`

export const Actions = styled.div`
  margin-top: 8px;
`
